import React from 'react';
import { useHistory } from 'react-router-dom';
import { ErrorPage } from '@guildeducationinc/recess';
import { useDecision } from '@optimizely/react-sdk';
import { LoadingOverlay } from 'src/components/LoadingOverlay';
import { CATALOG_MAINTENANCE_PAGE } from '@src/constants/featureFlags';

interface ErrorMessaging {
	errorTitle: string;
	errorMessage: string;
}

export const validateErrorMessaging = (
	errorTitle: string,
	errorMessage: string
): ErrorMessaging | null => {
	if (!errorTitle && !errorMessage) {
		return null;
	}

	return {
		errorTitle,
		errorMessage,
	};
};

const CustomErrorContent: React.FC<{
	errorMessaging: ErrorMessaging;
}> = ({ errorMessaging }) => {
	const history = useHistory();
	return (
		<ErrorPage
			goBack={history.goBack}
			message={errorMessaging.errorMessage}
			title={errorMessaging.errorTitle}
		/>
	);
};

const DefaultErrorContent: React.FC = () => {
	const history = useHistory();
	return <ErrorPage goBack={history.goBack}></ErrorPage>;
};

const ErrorPageContent = () => {
	const [decision] = useDecision(CATALOG_MAINTENANCE_PAGE);
	const variables = decision.variables;

	if (!variables || typeof variables !== 'object') {
		return <DefaultErrorContent />;
	}

	const errorTitle = variables.error_title as string;
	const errorMessage = variables.error_message as string;
	const loading = Object.keys(variables).length === 0;
	const errorMessaging = validateErrorMessaging(errorTitle, errorMessage);

	if (loading) {
		return <LoadingOverlay />;
	}
	if (errorMessaging) {
		return <CustomErrorContent errorMessaging={errorMessaging} />;
	}
	return <DefaultErrorContent />;
};

// https://guild-education.atlassian.net/l/cp/GfZHt2cv
export const MaintenancePage = ({ children }) => {
	const [decision] = useDecision(CATALOG_MAINTENANCE_PAGE);
	return decision.enabled ? <ErrorPageContent /> : children;
};
